import { redirect } from 'redux-first-router';
import { subscribeToNewsletter } from './checkout';
import { fetchData, fetchDepict } from '../utils/async';
import { removeLanguagePrefix } from '../utils/locale';
import { fieldValidation } from '../utils/string';

export const CHANGE_DEVICE = 'CHANGE_DEVICE';

export const INIT = 'INIT';
export const SITE_INIT = 'SITE_INIT';
export const SET_QUERY = 'SET_QUERY';

export const OPEN_MENU = 'OPEN_MENU';
export const EXPAND_MENU_ITEM = 'EXPAND_MENU_ITEM';
export const OPEN_CART = 'OPEN_CART';

export const INPUT_FIELD_UPDATE = 'INPUT_FIELD_UPDATE';
export const FORM_SUBMITTED = 'FORM_SUBMITTED';

export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

export const UPDATE_EVENT_DETAILS = 'UPDATE_EVENT_DETAILS';
export const UPDATE_EVENT_DETAILS_ERRORS = 'UPDATE_EVENT_DETAILS_ERRORS';

export const PARTICIPANTS_REGISTERED = 'PARTICIPANTS_REGISTERED';
export const PARTICIPANTS_ERROR = 'PARTICIPANTS_ERROR';

/*
	USER SETTINGS
*/
export const changeDevice = (breakPoint) => ({ type: CHANGE_DEVICE, breakPoint });

/*
	INTERACTION EVENTS
*/

export const openMenu = () => ({ type: OPEN_MENU });

export const expandMenuItem = (index) => ({ type: EXPAND_MENU_ITEM, index });

let openCartTimeout;
export const openCart = (open) => (dispatch, getState) => {
	const cartCurrentState = getState().environment.properties.openCart;
	if ((cartCurrentState === 0 && open === false) || openCartTimeout) return null;
	if (cartCurrentState === 1) {
		openCartTimeout = setTimeout(() => {
			dispatch({ type: OPEN_CART });
			openCartTimeout = false;
		}, 300);
	}
	return dispatch({ type: OPEN_CART });
};

export const goToPage = (path, options = {}) => (dispatch, getState) => {
	const { replace = false } = options;
	const language = getState().environment.setup.language;
	const extra = {};
	const pathSections = removeLanguagePrefix(path).split('/').reduce((acc, section) => {
		if (section !== '' && section !== language) {
			if (section.indexOf('#') !== -1) {
				extra.hash = section.slice(section.indexOf('#') + 1);
				section = section.slice(0, section.indexOf('#'));
			}
			if (section.indexOf('?') !== -1) {
				extra.search = decodeURI(section.slice(section.indexOf('?') + 1));
				extra.query = decodeURI(section.slice(section.indexOf('?') + 1)).split('&').reduce((acc2, segment) => {
					const [key, value] = segment.split('=');
					acc2[key] = decodeURI(value);
					return acc2;
				}, {});
				section = section.slice(0, section.indexOf('?'));
			}
			return [...acc, section];
		}
		return acc;
	}, []);

	if (pathSections[0] === 'selection' && pathSections.length === 1) {
		if (replace) return dispatch(redirect({ type: 'SELECTION', payload: { language } }));
		return dispatch({ type: 'SELECTION', payload: { language } });
	}
	if (pathSections.length === 0) {
		if (replace) return dispatch(redirect({ type: 'START', payload: { language } }));
		return dispatch({ type: 'START', payload: { language } });
	}
	if (replace) return dispatch(redirect({ type: 'CATEGORY_PRODUCT_PAGE', payload: { language, path: pathSections.join('/'), ...extra } }));
	return dispatch({ type: 'CATEGORY_PRODUCT_PAGE', payload: { language, path: pathSections.join('/'), ...extra } });
};

export const goToProduct = (path) => (dispatch, getState) => {
	const language = getState().environment.setup.language;
	return dispatch({ type: 'CATEGORY_PRODUCT_PAGE', payload: { language, path } });
};

export const retrieveProductCache = () => ({ type: 'RETRIEVE_PRODUCT_CACHE' });

/*
	FORM EVENTS
*/

export const inputFieldUpdate = (field, section, value, valid) => ({ type: INPUT_FIELD_UPDATE, field, section, value, valid });

export const formSubmitted = (section) => ({ type: FORM_SUBMITTED, section });

/*
	TRANSITION EVENTS
*/

export const removeNotification = (notificationType, notificationName) => ({ type: REMOVE_NOTIFICATION, notificationType, notificationName });

/*
	FILTER ACTIONS
*/

export const updateFilter = (filterArray, force = false) => ({ type: 'FILTER', filterArray, force });

export const clearFilter = () => ({ type: 'CLEAR_FILTER' });

export const resetFilter = () => ({ type: 'RESET_FILTER' });

export const searchInput = (text) => ({ type: 'SEARCH', text });

/*
	PAGINATION
*/

export const updatePagination = (currentPath, currentPage) => ({ type: 'UPDATE_PAGINATION', currentPath, currentPage });

/*
	FAVOURITES
*/

export const toggleFavourite = (productId, currentPath) => (dispatch, getState) => {
	const { favourites, setup } = getState().environment;
	const product = getState().productCache[setup.market][setup.pricelist].products[productId];

	if (favourites.indexOf(productId) === -1 && typeof window.dataLayer !== 'undefined') {
		window.dataLayer.push({
			event: 'AddToWishlist',
			values: {
				value: product.price.priceAsNumber,
				currency: setup.countries[setup.country].currency,
				content_name: product.name,
				content_category: currentPath,
				content_ids: [`1/${setup.country.toLowerCase()}-${product.id}-s`],
			},
		});
	}
	return dispatch({ type: 'TOGGLE_FAVOURITE', productId });
};

export const changeFavouritesLayout = (layout) => ({ type: 'FAVOURITES_LAYOUT', layout });

/*
	LANGUAGE
*/

export const changeLanguage = (language) => (dispatch, getState) => {
	const { depict, setup } = getState().environment;
	if (depict[language] === undefined) {
		fetchDepict('listings', { merchant: 'aplace', market: setup.country === 'SE' ? 'se' : 'global', locale: language === 'en' ? 'en_GB' : 'sv_SE' }).then((data) => {
			dispatch({ type: CHANGE_LANGUAGE, language, depict: data });
			return data;
		}).catch((err) => console.log(err));
	} else {
		dispatch({ type: CHANGE_LANGUAGE, language });
	}
};

/*
	MAGAZINE LIST
*/

// Update CMS with users.
export const retrieveMagazinePage = (path) => (dispatch, getState) => (
	fetchData(path).then((data) => (
		dispatch({ type: 'PAGE_DATA', data, page: path })
	)).catch((err) => console.log(err))
);

/*
	EVENTS
*/

export const updateEventDetails = (id, value) => ({ type: UPDATE_EVENT_DETAILS, id, value });

export const updateEventDetailsErrors = (id, value) => {
	const fieldType = id === 'email' ? 'email' : 'text';
	const error = fieldValidation(value, fieldType);

	return ({ type: UPDATE_EVENT_DETAILS_ERRORS, id, error });
};

export const registerParticipants = (path, fields) => (dispatch, getState) => {
	const eventDetails = getState().environment.eventDetails;
	const skip = ['allowFriends', 'acceptTerms', 'subscribeToNewsletter'];
	const participants = [];
	const reCaptcha = window.grecaptcha.getResponse();
	let hasErrors = false;

	// Return errors if defined.
	Object.keys(fields).forEach((field) => {
		if (eventDetails[field] === undefined || fieldValidation(eventDetails[field], fields[field])) {
			dispatch({ type: UPDATE_EVENT_DETAILS_ERRORS, id: field, error: true });
			hasErrors = true;
		}
	});

	if (!eventDetails.acceptTerms) dispatch({ type: UPDATE_EVENT_DETAILS_ERRORS, id: 'acceptTerms', error: true });
	if (!reCaptcha) dispatch({ type: UPDATE_EVENT_DETAILS_ERRORS, id: 'reCaptcha', error: true });
	if (hasErrors || !eventDetails.acceptTerms || !reCaptcha) return dispatch({ type: PARTICIPANTS_ERROR });

	// Subscribe to newsletter if needed.
	if (eventDetails.subscribeToNewsletter && /\S/.test(eventDetails.email)) {
		dispatch(subscribeToNewsletter(eventDetails.email));
	}

	// Package details before sending.
	Object.keys(eventDetails).forEach((participantDetail) => {
		if (skip.indexOf(participantDetail) === -1) {
			const whooseDetail = participantDetail.indexOf('Friend') !== -1 && eventDetails.allowFriends ? 1 : 0;
			if (participants[whooseDetail] === undefined) participants[whooseDetail] = {};
			participants[whooseDetail][participantDetail.replace('Friend', '')] = eventDetails[participantDetail];
		}
	});

	// Update CMS with users.
	fetchData(`event/${path}`, { participants, acceptTerms: eventDetails.acceptTerms, reCaptcha }).then((data) => {
		if (!data.success) return dispatch({ type: PARTICIPANTS_ERROR, errors: data.errors });
		return dispatch({ type: PARTICIPANTS_REGISTERED });
	}).catch((err) => console.log(err));
};
